import { Skeleton } from '@/components/ui/skeleton';

function ChartSkeleton() {
	return (
		<div className='rounded-xl border border-border bg-card shadow-sm overflow-hidden'>
			<div className='border-b px-4 py-3 flex items-center gap-2'>
				<Skeleton className='h-7 w-7 rounded-lg' />
				<Skeleton className='h-4 w-32' />
			</div>
			<div className='px-2 py-3'>
				<Skeleton className='h-[180px] w-full rounded-lg' />
			</div>
		</div>
	);
}

export function LandingEventsDataSkeleton() {
	return (
		<>
			<div className='grid grid-cols-2 gap-2 sm:grid-cols-3'>
				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className='rounded-md border border-border bg-card p-3.5 flex flex-col gap-2'>
						<Skeleton className='h-3 w-16' />
						<Skeleton className='h-5 w-12' />
					</div>
				))}
			</div>
			<ChartSkeleton />
		</>
	);
}

export default function LandingEventsSkeleton({ showFilters = true }: { showFilters?: boolean }) {
	return (
		<div className='flex flex-col gap-4'>
			<div className='rounded-xl border border-border p-5 flex flex-col gap-2'>
				<Skeleton className='h-3 w-28' />
				<Skeleton className='h-9 w-20' />
				<Skeleton className='h-4 w-56' />
			</div>

			{showFilters ? (
				<>
					<div className='grid grid-cols-4 gap-1'>
						{Array.from({ length: 4 }).map((_, i) => (
							<Skeleton key={i} className='h-9 rounded-md' />
						))}
					</div>

					<Skeleton className='h-10 w-full rounded-md' />
				</>
			) : null}

			<LandingEventsDataSkeleton />
		</div>
	);
}
